<template>
  <div>
    <v-client-table :data="faces"
                    :columns="columns"
                    :options="options"
                    class="infoWindowMapTable">
      <div slot="affectations" slot-scope="props">
        <div :key="index" v-for="(affectation, index) in props.row.affectations">
          <div v-if="affectation.dateStart">{{affectation.annonceur}}
            (du {{affectation.dateStart}} au {{affectation.dateEnd}} )</div>
        </div>
      </div>
      <div slot="affectationsReseaux" slot-scope="props">
        <div :key="index" v-for="(affectation, index)
                 in props.row.affectationsReseaux">
          <div v-if="affectation.dateStart">{{affectation.resLibelle}}
            (du {{affectation.dateStart}} au {{affectation.dateEnd}} )</div>
        </div>
      </div>
      <div slot="Disponibilite" slot-scope="props"
           class="image is-24x24 button noHandCursor centrer_disponibilite"
           v-bind:class="props.row.dispoClass">
      </div>
    </v-client-table>
  </div>

</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, RESULTS_PER_PAGE, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import moment from 'moment';

const Numerique = createNamespacedHelpers('venteNumerique');

export default {
  name: 'liste-affectations',
  props: ['panneau'],
  data() {
    return {
      trad: {
        facCode: 'Spot',
        affectations: 'Affectations LC',
        affectationsReseaux: 'Affectations Réseaux',
        selected: '',
        Disponibilite: 'Dispo',
      },
    };
  },
  computed: {
    ...Numerique.mapGetters({
      dateStart: 'dateStart',
      dateEnd: 'dateEnd',
    }),
    faces: {
      get() {
        const faces = [];
        this.panneau.panneauOrigine.faces.forEach((el) => {
          const face = {
            facCode: el.facCode,
            affectations: [],
            affectationsReseaux: [],
            panNum: this.panneau.panneauOrigine.num,
            facNum: el.facNum,
            urlPhoto: el.urlPhoto,
            dispoClass: niveauDispo.CLASS_NIVEAU_DISPONIBILITE[el.niveauDisponibilite],
          };
          el.affectations.forEach((affectation) => {
            if (moment(affectation.dateDebut) <= moment(this.dateEnd)
              && moment(affectation.dateFin) >= moment(this.dateStart)) {
              const dateStart = moment(affectation.dateDebut).format('DD/MM/YYYY');
              const dateEnd = moment(affectation.dateFin).format('DD/MM/YYYY');
              face.affectations.push({ annonceur: affectation.annonceur,
                dateStart: dateStart,
                dateEnd: dateEnd });
            }
          });
          el.affectationsReseaux.forEach((affectation) => {
            if (moment(affectation.deteDebut) <= moment(this.dateEnd)
              && moment(affectation.dateFin) >= moment(this.dateStart)) {
              const dateStart = moment(affectation.dateDebut).format('DD/MM/YYYY');
              const dateEnd = moment(affectation.dateFin).format('DD/MM/YYYY');
              face.affectationsReseaux.push({ resLibelle: affectation.resLibelle,
                dateStart: dateStart,
                dateEnd: dateEnd });
            }
          });
          faces.push(face);
        });
        faces.sort((a, b) => {
          if (a.facCode < b.facCode) return -1;
          else if (a.facCode === b.facCode) return 0;
          return 1;
        });
        return faces;
      },
    },
    columns() {
      return ['Disponibilite', 'facCode', 'affectations', 'affectationsReseaux'];
    },
    options() {
      return {
        headings: {
          facCode: this.trad.facCode,
          affectations: this.trad.affectations,
          affectationsReseaux: this.trad.affectationsReseaux,
          selected: this.trad.selected,
          Disponibilite: this.trad.Disponibilite,
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          selected: 'iconesModalAffectationVenteLc',
          Disponibilite: 'iconesModalAffectationVenteLc',
        },
      };
    },
  },
  methods: {
  },
};
</script>

<style>
  .iconesModalAffectationVenteLc {
    width: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/recherche/cartographie/listeAffectations.vue